const React = require("react");
const PropTypes = require("prop-types");
const classNames = require("classnames");

const Well = ({ children, variant }) => {
  const classes = classNames("well", {
    "well--primary": variant === "primary",
    "well--secondary": variant === "secondary",
    "well--warning": variant === "warning",
  });
  return <div className={classes}>{children}</div>;
};

Well.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary", "warning", "none"]),
};

Well.defaultProps = {
  variant: "none",
};

module.exports = Well;
